import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AssignedClientsApiService } from 'features/assigned-clients/api/assign-clients-api.service';
import { queryClient } from 'providers';

import { AssignClientsQueryKeys } from './query-keys';

const { UploadRequestDocuments } = AssignedClientsApiService();

export const useRequestUpload = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: FormData) => {
      return UploadRequestDocuments(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        queryClient.invalidateQueries({
          queryKey: AssignClientsQueryKeys.all,
        });
        if (data.rs == 1) {
          message.success('Request Documents Upload successfully');
        }
      },
    },
  );
};
